import React from "react";

import StringsContext from "./strings-context";

const StringsProvider = ({ strings, children }) => (
  <StringsContext.Provider value={strings}>
    {children}
  </StringsContext.Provider>
);

export default StringsProvider;
